<template>
  <GlobalAlertWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-descriptions direction="horizontal" labelClassName="descriptions-label" :column="1">
      <el-descriptions-item label="会员昵称">{{ form.nickName }}</el-descriptions-item>
      <el-descriptions-item label="真实姓名">{{ form.name }}</el-descriptions-item>
      <el-descriptions-item label="手机号">{{ form.phone }}</el-descriptions-item>
      <el-descriptions-item label="身份证号">{{ form.idcard }}</el-descriptions-item>
      <el-descriptions-item label="性别">{{ form.sex==0?'男':form.sex==1?'女':'未知' }}</el-descriptions-item>
      <el-descriptions-item label="地区">{{ form.addr }}</el-descriptions-item>
      <el-descriptions-item label="一句话介绍">{{ form.info }}</el-descriptions-item>
    </el-descriptions>
    <div slot="footer"></div>
  </GlobalAlertWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalAlertWindow from '@/components/common/GlobalAlertWindow'
export default {
  name: 'OperaCouponWindow',
  extends: BaseOpera,
  components: { GlobalAlertWindow },
  data () {
    
    return {
      getDate: [],
      // 表单数据
      form: {
        id: null,
        name: '',
        nickName: '',
        sex: '',
        addr: '',
        phone: '',
        idcard: '',
        info: ''
      },
      
    }
  },
  created () {
    this.config({
      api: '/business/coupon',
      'field.id': 'id'
    })
  },
  methods: {
    
  },
}
</script>

<style lang="scss">
.descriptions-label {
  width: 80px;
  text-align: right !important;
  display: block !important;;
}
</style>

